<template>
  <b-container fluid class="login-container overflow-hidden p-0">
    <b-row no-gutters class="h-100">
      <b-col md="7" class="card-boas-vindas">
        <div
          :class="
            isDev
              ? 'bg-dev'
              : isHml
              ? 'bg-hml'
              : 'bg-prd'
          "
        >
          <h1>Portal do TCE</h1>
          <h1>Protocolo Eletrônico</h1>
        </div>
      </b-col>
      <b-col
        sm="12"
        md="5"
        class="bg-white d-flex flex-column justify-content-between align-items-stretch"
      >
        <div class="header-area">
          <b-navbar type="light" variant="light">
            <b-navbar-nav class="navbar">
              <b-nav-item
                href="https://www.tce.se.gov.br/SitePages/jurisdicionado.aspx"
              >
                <font-awesome-icon icon="book" /> Documentação</b-nav-item
              >
              <span>|</span>
              <b-nav-item href="#">
                <font-awesome-icon icon="book" /> Sharepoint</b-nav-item
              >
              <span>|</span>
              <b-nav-item href="https://tce.se.gov.br">
                <font-awesome-icon icon="address-card" /> Página
                Principal</b-nav-item
              >
            </b-navbar-nav>
          </b-navbar>
          <b-img src="logo.png" height="180" alt="Logo TCE" class="my-5" />
          <h2 class="text-center font-weight-bold pt-0">Login Interno</h2>
        </div>

        <ValidationObserver
          ref="validationobserver"
          v-slot="{ handleSubmit }"
          class="mx-3"
        >
          <b-form
            @submit.prevent="handleSubmit(login)"
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div
              class="loginForm mw-100 d-flex flex-column justify-content-center align-items-center"
            >
              <DefaultFormValidationProvider
                label="Usuário (@tce.se.gov.br)"
                v-slot="defaultState"
                class="w-100"
              >
                <b-form-input
                  id="input-usuario"
                  v-model="usuario"
                  :state="defaultState.state"
                  autofocus
                  autocomplete="username"
                />
              </DefaultFormValidationProvider>
              <DefaultFormValidationProvider
                label="Senha"
                v-slot="defaultState"
                class="w-100"
              >
                <b-form-input
                  id="input-senha"
                  v-model="senha"
                  :state="defaultState.state"
                  type="password"
                  autocomplete="current-password"
                />
              </DefaultFormValidationProvider>
            </div>
            <b-row>
              <b-col cols="12" class="d-flex justify-content-center">
                <b-button
                  class="m-1"
                  :variant="
                    isDev
                      ? 'secondary'
                      : isHml
                      ? 'primary'
                      : 'success'
                  "
                  size="sm"
                  type="submit"
                >
                  <font-awesome-icon icon="keyboard" class="mr-2" />
                  Entrar
                </b-button>
                <b-button
                  variant="outline-secondary"
                  disabled
                  class="m-1"
                  size="sm"
                >
                  <font-awesome-icon icon="lock" class="mr-2" />
                  Esqueci a senha
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>

        <footer class="footer py-3 w-100">
          <p class="mb-0">
            <font-awesome-icon icon="envelope" />
            <a
              class="link"
              href="mailto:integracao.jurisdicionado@tce.se.gov.br"
              >integracao.jurisdicionado@tce.se.gov.br</a
            >
          </p>
          <p class="mb-0">
            <font-awesome-icon icon="phone" />
            <a class="link" href="tel:+557932164433">(79) 3216-4433</a>
          </p>
        </footer>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { isDev, isHml, store, updateToken } from "@/store";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Ref } from "vue-property-decorator";
import usuarioService from "@/services/administracao/usuarioService";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

const CompProps = Vue.extend({
  name: "LoginInternoComponent",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
  },
});

@Component
export default class LoginInternoComponent extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  senha = "";
  usuario = "";
  isDev = isDev()
  isHml = isHml()

  async login(): Promise<void> {
    store.blockScreen = true;
    try {
      const ld = await usuarioService.loginInterno(this.usuario, this.senha);

      if (ld.termosPendentes && ld.termosPendentes.length)
        store.termoPendente = ld.termosPendentes[0];
      await updateToken(
        ld.token,
        ld.cpf,
        null,
        ld.nomeUsuario,
        ld.primeiroAcesso,
        ld.permissoes,
        null,
        ld.email,
        ld.nextStep,
        ld.idUsuario
      );

      switch (ld.nextStep) {
        case "index":
          this.$router.push("/inicio");
          break;
        case "trocar-senha":
          this.$router.push("/seguranca-administracao/trocar-senha");
          break;
        default:
          this.$toast.error(
            "Não foi possível identificar a rota correta do Usuário!"
          );
      }
    } catch (e: unknown) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style scoped>
div.login-container {
  height: 100vh;
}

.card-boas-vindas h1 {
  font-size: 4rem;
  font-optical-sizing: auto;
  font-weight: bold;
  font-style: normal;
}

.bg-dev {
  background-image: url("../../assets/Curve-Line-Gray.svg");
  height: 100%;
  background-repeat: no-repeat;

  background-size: cover, contain;

  background-position: right, bottom;

  color: white;

  text-align: center;

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;

  @media (max-width: 767px) {
    display: none;
  }
}

.bg-hml {
  background-image: url("../../assets/Curve-Line-Blue.svg");
  height: 100%;
  background-repeat: no-repeat;

  background-size: cover, contain;

  background-position: right, bottom;

  color: white;

  text-align: center;

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;

  @media (max-width: 767px) {
    display: none;
  }
}

.bg-prd {
  background-image: url("../../assets/Curve-Line2.svg");
  height: 100%;
  background-repeat: no-repeat;

  background-size: cover, contain;

  background-position: right, bottom;

  color: white;

  text-align: center;

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;
}

.footer {
  bottom: 0;
  width: 100%;

  /* Cor clara */
  color: #6c757d;
  /* Texto cinza */
  font-size: 0.9rem;
}

.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.5rem;
}

.link {
  color: #6c757d;
}
</style>
